import { call, put, takeEvery } from 'redux-saga/effects';
import { searchUsers } from '../../../telephony/api/telephony';
import { addCallerActions } from '../actions/addCaller';
import * as api from '../api/addCaller';
const { addCallerCallRequest, addCallerCallRequestSucceeded, addCallerCallRequestFailed, addCallerRemoveCallerRequest, addCallerRemoveCallerRequestSucceeded, addCallerRemoveCallerRequestFailed, addCallerSetOnHoldRequest, addCallerSetOnHoldRequestSucceeded, addCallerSetOnHoldRequestFailed, addCallerGetUsersByQuery, addCallerGetUsersByQuerySucceeded, addCallerGetUsersByQueryFailed, } = addCallerActions;
export const addCaller = [
    takeEvery(addCallerCallRequest.toString(), apiGenWithPromise(api.addCallerRequest, addCallerCallRequestSucceeded, addCallerCallRequestFailed)),
    takeEvery(addCallerRemoveCallerRequest.toString(), apiGenWithPromise(api.removeCallerRequest, addCallerRemoveCallerRequestSucceeded, addCallerRemoveCallerRequestFailed)),
    takeEvery(addCallerSetOnHoldRequest.toString(), apiGenWithPromise(api.setHoldStatusOnCallerRequest, addCallerSetOnHoldRequestSucceeded, addCallerSetOnHoldRequestFailed)),
    // @TODO should this not be a takeLatest ?
    takeEvery(addCallerGetUsersByQuery.toString(), apiGenWithPromise(searchUsers, addCallerGetUsersByQuerySucceeded, addCallerGetUsersByQueryFailed)),
];
function apiGenWithPromise(apiCall, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        try {
            result = yield call(apiCall, action.payload);
            result.meta.request = action.payload;
            if (action.meta && action.meta.resolve) {
                yield call(action.meta.resolve, result);
            }
            yield put(resultSucceededAction(result));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            if (action.meta && action.meta.reject) {
                yield call(action.meta.reject, exception);
            }
            result = exception;
            yield put(resultFailedAction({ action: action, result: result }));
        }
    };
}
